// extracted by mini-css-extract-plugin
module.exports = {"oauthButton":"OAuthStep_oauthButton__cD0vI"};